export default __webpack_public_path__ + "static/CDP-ed63a443cf42ff3e824af20a9af5005f.png";